module.exports = __webpack_public_path__ + "img/guessBig.73a4d01b.svg";